import {useEffect, useCallback} from 'react'
import ApiSdk from 'services/callApi'
import {useDispatch} from 'redux-react-hook'
import {entities as entitiesAction, orderUpdate as orderUpdateAction} from 'actions'
import {WS_ROOT} from 'constants'
import {futuresStreamers} from '@binance/js-sdk'
import useUserLoginStatus from './useUserLoginStatus'
import useOpenFutureStatus from './useOpenFutureStatus'

function useUserDataStreamer (symbol, collateral = 'USDT') {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const ifOpenFuture = useOpenFutureStatus()
  const fetchData = useCallback(async () => {
    if (isLogin && ifOpenFuture) {
      ApiSdk.futures.getPositionList({collateral}).then(({positions, error}) => {
        if (!error) {
          const fakeId = 10010010
          positions = positions || {
            [symbol]: {
              askNotional: 0,
              bidNotional: 0,
              entryPrice: 0,
              futureUid: fakeId,
              id: `${fakeId}_${symbol}`,
              notionalValue: 0,
              positionSize: 0,
              symbol,
              unrealizedProfit: 0
            }
          }
          dispatch(entitiesAction({positions}))
        }
      })

      ApiSdk.futures.getBalance({asset: collateral}).then(({balances = {}, error}) => {
        if (!error) dispatch(entitiesAction({balances}))
      })
    }
  }, [collateral, dispatch, isLogin, symbol, ifOpenFuture])

  const createSocketClient = useCallback(async () => {
    if (isLogin && ifOpenFuture) {
      const key = await ApiSdk.futures.getListenKeyData()
      const userStreamer = new futuresStreamers.PositionStreamer(WS_ROOT, key)
      userStreamer.subscribe(eventData => {
        const {type, data, positions} = eventData
        if (type === 'ORDER_TRADE_UPDATE') {
          dispatch(orderUpdateAction({...data, pushed: true}))
          dispatch(entitiesAction({positions}))
        } else if (type === 'ACCOUNT_UPDATE') {
          dispatch(entitiesAction(data))
        }
      })
      return userStreamer
    }
  }, [dispatch, isLogin, ifOpenFuture])

  useEffect(() => {
    if (!isLogin) return
    fetchData()
    createSocketClient()
  }, [createSocketClient, dispatch, fetchData, isLogin, symbol])
}

export default useUserDataStreamer
